import { Box, Button, Typography, useTheme } from "@mui/material";
import React from "react";
import logo from "../../assets/Logo.png";
import { useNavigate } from "react-router-dom";
import { decodeJWT, MIDDLEWARE_API_URL, sentActionLog, verify } from "../../utils/common";
import useUser from "../../hooks/useUser";
import { User } from "../../models";

const Login: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { setUser } = useUser();
  const handleOnClick = () => {
    window.location.href = `${MIDDLEWARE_API_URL}/saml2/login/`;
  };

  React.useEffect(() => {
    (async () => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const token = urlParams.get('token');
      if(token){
        localStorage.setItem("jwt",token);
        if(await verify(token)){
          const tokenInfo = decodeJWT(token);
          if(tokenInfo){
            const userInfo: User = {
              id: tokenInfo.user_id,
              username: tokenInfo.username,
              administrationAccess: tokenInfo.administrationAccess,
              permissions: tokenInfo.permissions,
              firstName: tokenInfo.firstName,
              lastName: tokenInfo.lastName,
              cmsProfile: tokenInfo.cmsProfile ?? null
            }
            localStorage.setItem("user", JSON.stringify(userInfo));
            if(tokenInfo.cmsProfile) {
              localStorage.setItem("cmsProfile", JSON.stringify(tokenInfo.cmsProfile));
            }
            setUser(userInfo);
            sentActionLog('Login', `usuario accedio a plataforma`);
            navigate("/Home");
          }
        }
      } else {
        const currentToken = localStorage.getItem("jwt");
        if(currentToken){
          if(await verify(currentToken)){
            navigate("/Home");
          }
        }
      }
    })()
  },[navigate, setUser]);

  return (
    <Box
      bgcolor={theme.palette.background.default}
      color={"white"}
      height={"100vh"}
    >
      <Box textAlign="center" pt="15vh">
        <img src={logo} alt="logo" />
      </Box>
      <Box textAlign="center">
        <Typography variant="h4">Bienvenido</Typography>
        <Typography mt={5} variant="subtitle2">
          Tu viaje a una nueva experiencia, comienza ahora
        </Typography>
      </Box>
      <Box textAlign="center" width={"80%"} margin="40px auto">
        <Button
          variant="contained"
          color="info"
          fullWidth
          style={{ borderRadius: "20px" }}
          onClick={handleOnClick}
        >
          Ingresar
        </Button>
      </Box>
    </Box>
  );
};

export default Login;
